<template>
      <v-tooltip bottom>
      <v-btn
        style="min-width: 109px;"
        slot="activator"
        @click.native="dialog = !dialog"
        class="bg_white"
      >
        <v-icon small color="teal" style="margin-right: 6px;">cloud_upload</v-icon>
        <small style="color:black;" v-if="component.tipo === 'recebida'">Upload Planilha</small>
      </v-btn>
      <span v-if="component.tipo === 'recebida'">Upload Planilha</span>



    <v-dialog @keydown.esc="dialog = false" v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span>
            <strong v-if="component.tipo === 'recebida'">Upload de planilha</strong>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="resetInfos(true)">
            <v-icon color="red">close</v-icon>
          </v-btn>
        </v-card-title>

          <v-card-text>
            <v-container>

              <span class="inputFile">
                <label for="file-upload" class="custom-file-upload" @click="resetInfos(false)">
                  <v-icon>mdi-file</v-icon>
                  {{  path ? path : 'Selecione um arquivo'}}
                </label>
                <small>
                  {{fileText}}
                  <span class="teal_bold">{{path}}</span>
                </small>
                <input
                  type="file"
                  @change="setFile($event)"
                  name="file-upload"
                  value="file"
                  @keypress.enter.prevent
                  @keydown.enter.prevent
                  id="file-upload"
                  :accept="'.xlsx'"
                />
                <br />
              </span>

              </v-container>
          </v-card-text>

          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.stop="resetInfos(true)">Fechar</v-btn>
          <v-btn v-if="component.tipo === 'recebida'" color="success" @click.stop="handleUpload">Upload</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAviso" persistent width="90%" max-width="90%" min-width="90%">
          <v-card>
            <v-toolbar dark class="headline darkBlue">
              <v-toolbar-title>Aviso</v-toolbar-title>
              <v-spacer></v-spacer>

            </v-toolbar>
            <article>

              <div style="margin-left: 50px;">
                <btnExpExcell
                  :component="this.component"
                  :table="tableErros"
                  :nfseErros="true"
                ></btnExpExcell>
              </div>

              <v-card-text>
                <v-container>
                  <h3>Foram encontrados erros nos campos da planilha.</h3>
                  <br>
                  <v-data-table
                    :headers="headers"
                    :items="items"
                    class="elevation-1"
                    :id="tableId"
                    rows-per-page-text="Linhas por página:"

                    :rows-per-page-items="pagination.rowsPerPageItems"
                    :pagination.sync="pagination"
                  >

                    <!-- Template Planilha -->
                    <template v-slot:items="props">
                      <td class="text-xs-center">{{props.item.cnpjCpfPrestador != undefined ? (props.item.cnpjCpfPrestador.length > 11 ? props.item.cnpjCpfPrestador.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : props.item.cnpjCpfPrestador.replace(/^(\d{3})(\d{3})(\d{3})(\d)/,"$1.$2.$3-$4") ) : ''}}</td>
                      <td class="text-xs-center">{{ props.item.razaoPrestador }}</td>
                      <td class="text-xs-center">{{ props.item.erro }}</td>
                      <td class="text-xs-center">{{ props.item.numero }}</td>
                    </template>
                    <template slot="pageText" slot-scope="props">
                      <strong>
                        Exibindo {{ props.pageStart }} - {{ props.pageStop }} do total de {{ quantity }}
                       
                        <span>{{ quantity === 1 ? 'Erro' : 'Erros' }}</span>
                      </strong>.
                    </template>
                  </v-data-table>
                  </v-container>
              </v-card-text>
              

              <v-container grid-list-md text-xs-center style="padding-top: 2px;">
                <v-layout row wrap v-if="duplicidade">
                  <v-flex xs6>
                    <v-btn
                      block
                      outline
                      depressed
                      small
                      color="red"
                      @click="dialogAviso=false"
                    >Cancelar</v-btn>
                  </v-flex>
                  <v-flex xs6>
                    <v-btn
                      :disabled="!checkboxDuplicidades"
                      block
                      depressed
                      class="white--text"
                      small
                      color="teal"
                      @click="handleErros"
                    >Incluir</v-btn>
                  </v-flex>
                </v-layout>

                <v-layout row wrap v-else>
                  <v-flex xs12>
                    <v-btn
                      block
                      outline
                      depressed
                      small
                      color="blue"
                      @click="dialogAviso=false"
                    >Fechar</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
              </article>
          </v-card>
        </v-dialog>

    </v-tooltip>
</template>
<script>

import NfseService from "@/domain/notas/nfse/NfseService";
import zlib from 'zlib';
import btnExpExcell from '../btnExpExcell/BtnExpExcell';
import io from 'socket.io-client';

export default {
  props: ["conta", "component", "empresa", "table", "conta", "alert"],
  components: {
    btnExpExcell: btnExpExcell,
  },
  data: () => ({
    checkboxDuplicidades: false,
    dialog: false,
    dialogAviso: false,
    fileText: "Nenhum arquivo selecionado",
    path: "",
    file: {},
    formData: new FormData(),
    cnpj: '',
    dataServico: '',
    vlEnviado: '',
    dtEmissao: null,
    duplicidade: null,
    quantity: 0,
    tableErros: null,
    headers: [],
      items: [],
      pagination: {
        rowsPerPage: 10,
        rowsPerPageItems: [10, 30 , 50],
        sortBy: 'nome',
        page: 1,
      },
      socket: null,
      tableId: '',
  }),
  created() {
    this.socket = io(this.$http.options.root, {
      transports: ['websocket'],
      secure: true,
      query: {
        "user_id": this.conta.id_usuario,
        "sessionId": this.$session.id(),
      },
    });
  },
  mounted() {
    this.socket.on('processandoPlanilhaEscrituracao', (resp) => {
      const percent = (resp.inseridas / resp.totalNotas) * 100;
      this.$store.commit('addProgressBar', Math.ceil(percent));
    });

  },
  computed: {
    paginationNumber() {
      const errors = this.quantity;
      const rows = this.pagination.rowsPerPage;

      if(errors <= 10){
        return 1;
      }
      else if ( errors >= rows ) {
        return Math.ceil(errors / rows, 1);
      } else {
        return Math.ceil(rows / errors, 1);
      }
    },
  },
  destroyed() {
    this.socket.disconnect();
  },
  methods: {
    resetInfos(closeDialog) {
      let file = document.querySelector("#file-upload");
      file.value = "";

      this.path = "";
      this.fileText = "Nenhum arquivo selecionado";
      if(closeDialog) {
        this.dialog = false;
      }else {
        this.dialog = true;
      }
    },
    setFile: function(e) {
      this.path = "";
      if (e.target.type == "file") {
        if (e.target.files.length > 0) {
          this.fileText = "Arquivo selecionado: ";
          this.path = e.target.files[0].name;
          this.file = e.target.files[0];
        } else {
          this.fileText = "Nenhum arquivo selecionado";
        }
      }else {
          return;
      }
    },
    activeGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const loading = document.querySelector(".c_custom-progress");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      const h4Msg = document.querySelector('.c_custom-msg');
      h4Msg.textContent = 'Aguarde enquanto a planilha é processada.';
      h4Msg.classList.add("loading_global");
      body.classList.add("loading_global");
      html.classList.add("loading_global");
      appDom.classList.add("loading_global");

      icon.classList.add("loading_global");
      loading.classList.add("loading_global");
    },
    desactiveGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      const loading = document.querySelector(".c_custom-progress");
      const h4Msg = document.querySelector('.c_custom-msg');
      h4Msg.textContent = 'Aguarde enquanto a planilha é processada.';
      h4Msg.classList.remove("loading_global");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
      loading.classList.remove("loading_global");
    },
  
    async handleUpload() {
      this.headers = [];
      this.formData = new FormData();
  
      if(this.file) {
        this.formData.append('file', this.file);
        this.headers.push(
          { text: 'CNPJ/CPF Prestador', align: 'center', value: 'cnpjCpfPrestador' },
          { text: 'Razao Prestador', align: 'center', height: '37', value: 'razaoPrestador' },
          { text: 'Erro', align: 'center', value: 'erro' },
          { text: 'Número da Nota', align: 'center', value: 'numero' }
        );
        this.resetInfos(true);
        this.service = new NfseService(this.$http);
        this.table.loading = true;
        this.activeGlobalLoader();
        await this.service.enviarPlanilhaEscrituracao(this.formData, this.empresa._id).then( async (response) => {
          if(response) {
            this.table.loading = false;
            this.socket.on('responsePlanilhaEscrituracao', (resp) => {
              if(resp.erros && resp.erros.length > 0) {

                this.quantity = resp.erros.length;
                this.items = [];

                resp.erros.map(erro => {
                  this.items.push({
                    cnpjCpfPrestador: erro.cnpjCpfPrestador,
                    razaoPrestador: erro.razaoPrestador,
                    erro: erro.erro,
                    numero: erro.numero
                  })
                });
                this.tableId = 'tableErros';
                this.duplicidade = this.items.find(item => item.erro.toLowerCase().indexOf('duplicidade') > -1);
                this.table.loading = false;
                this.tableErros = {};
                this.tableErros.array_todas_notas = this.items;
                this.tableErros.arrayNotas = this.items;
                this.tableErros.pagination = this.pagination;
                this.desactiveGlobalLoader();
                this.dialogAviso = true;

              }else {
                this.desactiveGlobalLoader();
                this.table.loading = false;
                this.alert.snackSuccess();
                this.alert.snack.time = 10000;
                this.alert.snack.text = "Planilha importada com sucesso";
                this.alert.snack.show = true;
                this.$store.commit('addUpdateTable', true);
              }
              this.$store.commit('addProgressBar', 0);
            });
          }else {
            this.table.loading = false;
            this.desactiveGlobalLoader();
            this.alert.snackDanger();
            this.alert.snack.time = 10000;
            this.alert.snack.text = "Erro interno, favor constatar o administrador do sistema";
            this.alert.snack.show = true;
          }
        })

      }
    },
    async handleErros() {
      this.service = new NfseService(this.$http);
      // if(this.checkboxDuplicidades) {
      //   this.dialogAviso = false;
      //   this.table.loading = true;
      //   this.items.map(async (item) => {
      //     if(item.erro.toLowerCase().indexOf('duplicidade') > -1) {
      //       const json = {
      //         dataServico: item.emissao.dataServico,
      //         cpfCnpj: item.emissao.cpfCnpj,
      //         razao: item.emissao.razao,
      //         email: item.emissao.email,
      //         cep: item.emissao.cep,
      //         estado: item.emissao.estado,
      //         codMun: item.emissao.codMun,
      //         bairro: item.emissao.bairro,
      //         logradouro: item.emissao.logradouro,
      //         numero: item.emissao.numero,
      //         complemento: item.emissao.complemento,
      //         codigoTributacao: '0403-0/04-88 Convênio ou contrato celebrado com o SUS - sistema único de saúde para prestação de serviços de hospitais,clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres.',
      //         naturezaOperacao: 'Tributação no município',
      //         regimeTributacao: 'Estimativa',
      //         issqn: 'Belo Horizonte',
      //         telefone: item.emissao.telefone,
      //         valorTotal: item.emissao.valorTotal,
      //         discriminacao: item.emissao.discriminacao,
      //       }

      //       const respJson = { ...json, aceiteDuplicidade: this.conta.id_usuario };
      //       await this.service.inserirNovaNota(respJson);
      //     }
      //   })
      // }
      this.table.loading = false;
      this.$store.commit('addUpdateTable', true);
    },
  }
};
</script>
<style>
.inputFile {
  display: inline-block;
}
.inputFile input[type="file"] {
  display: none;
}
.inputFile .custom-file-upload {
  border-radius: 11px;
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
small.typeArquivo {
  color: grey;
  font-weight: 700;
  margin-left: 5px;
}
.teal_bold {
  color: teal;
  font-weight: bold;
}
#tableErros table.v-table thead tr,
#tableDes table.v-table thead tr {
  height: 33px;
}
</style>




// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnUploadPlanilha/BtnUploadPlanilhaEscrituracao.vue